export const TOOLTIP_PROPS = {
  placement: 'right',
  anchoredFixedPositionProps: {
    modifiers: {
      preventOverflow: {
        boundariesElement: 'viewport'
      }
    }
  }
} as const;
